export type LotTier = {
  id: 'village' | 'garden' | 'estate' | 'signature';
  name: string;
  number: string;
  category: string;
  tagline: string;
  size: string;
  startingPrice: string;
  startingPriceNum: number;
  totalLots: string;
  description: string;
  bestFor: string;
  privatePool: string;
  buildEnvelope: string;
  riverAccess: string;
  beachClub: string;
  rentalPotential: string;
};

export const lotTiers: LotTier[] = [
  {
    id: 'village',
    name: 'The Village',
    number: '01',
    category: 'Entry tier',
    tagline: 'Walkable cluster living. Where the community starts its day.',
    size: '200 to 300 m²',
    startingPrice: '$175K+',
    startingPriceNum: 175000,
    totalLots: '280 to 400',
    description:
      'Compact, walkable lots clustered near the village center: the beach club, the restaurant, the wellness pavilion. Designed for buyers who want to live in the community, not at the edge of it.',
    bestFor: 'Investors, entry buyers, rental income',
    privatePool: 'Shared pools nearby',
    buildEnvelope: '~120 m² home',
    riverAccess: 'Walking trail (2 to 6 min)',
    beachClub: '5 to 8 min walk',
    rentalPotential: 'Strong year-round',
  },
  {
    id: 'garden',
    name: 'The Garden',
    number: '02',
    category: 'Family tier',
    tagline: 'Private pool. Kitchen garden. Real outdoor rooms.',
    size: '500 to 1,000 m²',
    startingPrice: '$350K+',
    startingPriceNum: 350000,
    totalLots: '60 to 100',
    description:
      'The sweet spot of the project. Generous enough for a private pool, a garden, an outdoor kitchen, and meaningful separation from neighbors, without the maintenance burden of a finca-scale property.',
    bestFor: 'Families, second-home owners',
    privatePool: 'Yes, fits comfortably',
    buildEnvelope: '~200 to 300 m² home',
    riverAccess: 'Walking trail (1 to 4 min)',
    beachClub: '6 to 10 min walk',
    rentalPotential: 'Strong, premium nightly',
  },
  {
    id: 'estate',
    name: 'The Estate',
    number: '03',
    category: 'Privacy tier',
    tagline: 'Forest on every side. A finca scaled for retreat.',
    size: '2,000 to 4,000 m²',
    startingPrice: '$750K+',
    startingPriceNum: 750000,
    totalLots: '40 to 70',
    description:
      'Half-acre to a full acre, set deeper into the property where the canopy thickens. Room for a guest casita, a private wellness studio, a small cacao orchard, or simply the space to disappear when you want to.',
    bestFor: 'Privacy buyers, retreats, multi-gen',
    privatePool: 'Yes, plus guest pool',
    buildEnvelope: '~400 m² + casita',
    riverAccess: 'Direct trail or proximity',
    beachClub: '8 to 12 min · or shuttle',
    rentalPotential: 'Boutique retreat-grade',
  },
  {
    id: 'signature',
    name: 'The Signature',
    number: '04',
    category: 'Trophy tier',
    tagline: 'Riverfront or ridgeline. The legacy parcels of the project.',
    size: '5,000+ m²',
    startingPrice: '$1.75M+',
    startingPriceNum: 1750000,
    totalLots: '10 to 20',
    description:
      'A small number of trophy parcels on the river or the ridgeline: the lots that do not repeat in the masterplan. Once they are spoken for, the project does not make more of them. These are the pieces of Nativa that get passed down.',
    bestFor: 'Legacy buyers, trophy owners',
    privatePool: 'Infinity pool standard',
    buildEnvelope: '~600 m²+ compound',
    riverAccess: 'Often direct frontage',
    beachClub: 'Varies by parcel',
    rentalPotential: 'Ultra-premium, on request',
  },
];
